<div class="mtn-container">
    <div class="mtn-title">
        <p>{{ moduleName?.toUpperCase() }}</p>
    </div>
    <osp-table [tblConfig]="hazardGradeTblConfig" (onRowClick)="onRowClick($event)" [selectedRow]="selectedRow"></osp-table>
    <div id="hazard-grade-maintenance-loading">
        <div class="form-loader"></div>
    </div>
    <div *ngIf="showForm" class="form-content">
        <form [formGroup]="forms.hazardGradeForm" class="form">
            <div id="hazard-grade-error-message"></div>
            <div class="form-container-grid">
                <div class="field required">
                    <label>Hazard Grade Code</label>
                </div>
                <div class="">
                    <input formControlName="hazardGrdCd" maxlength="8" alphanumeric >
                </div>
                <div class="field required">
                    <label>Active</label>
                </div>
                <div class="">
                    <select formControlName="active">
                        <option *ngFor="let activeType of selections.activeTypes" [value]="activeType.cd">
                            {{activeType.name}}
                        </option>
                    </select>
                </div>
                <div class="field required">
                    <label>Hazard Grade Description</label>
                </div>
                <div class="span">
                    <input formControlName="hazardGrdDesc" maxlength="1000" >
                </div>
                <div class="field">
                    <label>Remarks</label>
                </div>
                <div class="span">
                    <input formControlName="remarks" maxlength="1000" >
                </div>
                <div class="field">
                    <label>Last Update User</label>
                </div>
                <div class="">
                    <input formControlName="lastUpdateUser" >
                </div>
                <div class="field">
                    <label>Last Update</label>
                </div>
                <div class="">
                    <input formControlName="lastUpdate" >
                </div>
            </div>
        </form>
        <div class="btn-grp">
            <button *ngIf="btns.hazardGrade.updateDisabled" class="btn btn2" type="button" (click)="onAdd()" [disabled]="btns.hazardGrade.addDisabled" >ADD</button>
            <button *ngIf="!btns.hazardGrade.updateDisabled" class="btn btn2" type="button" (click)="onUpdate()" >UPDATE</button>
            <button class="btn btn2" type="button" [disabled]='btns.hazardGrade.deleteDisabled' (click)="onDelete()" >DELETE</button>
        </div>
        <div class="mtn-title"></div>
        <div class="btn-grp">
            <button class="btn btn2" type="button" [disabled]='btns.hazardGrade.saveDisabled' (click)="onSave()" >SAVE</button>
        </div>
    </div>
</div>
